import React from "react";
import ReactTable from "react-table";
import { Link } from 'react-router-dom';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import '../../stylesheets/shared/react-table.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { impactStatementActionCreators } from '../../stores/lis-impact-statement-store';
import { sessionActionCreators } from '../../stores/lis-session-store';
import { cancelRequest } from '../../services/request.service';
import { navActionCreators } from "../../stores/lis-nav-store";
import { committeeActionCreators } from "../../stores/lis-committee-store";
import { billActionCreators } from "../../stores/lis-legislation-store";

const selectStyle = {
    container: styles => ({
        ...styles,
        minWidth: '150px',
        height: "32px"
    }),
    control: styles => ({
        ...styles,
        minHeight: '0px',
        padding: '0.12em 0.6em !important',
        height: "32px"
    }),
    valueContainer: styles => ({
        ...styles,
        padding: 0,
        height: "32px"
    }),
    input: styles => ({
        ...styles,
        fontSize: '0.8em',
        lineHeight: 'normal',
        height: "32px"
    }),
    singleValue: styles => ({
        ...styles,
        fontSize: '0.8em',
        paddingBottom: "8px"
    }),
    placeholder: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    option: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    dropdownIndicator: styles => ({
        ...styles,
        padding: '0px 8px'
    }),
    menu: provided => ({
        ...provided,
        whiteSpace: 'nowrap',
        width: 'fit-content'
    })
};

class ImpactStatementGridComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            billNumber: "",
            calendarDate: "",
            status: "",
            committee: "",
            subcommittee: "",
            isLoaded: false,
            impactStatements: [],
            billStatusReferences: [],
            currently: true
        };

        this.fetchTableData = this.fetchTableData.bind(this);
        this.handleBillNumberChange = this.handleBillNumberChange.bind(this);
        this.handleCalendarDateChange = this.handleCalendarDateChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleCommitteeChange = this.handleCommitteeChange.bind(this);
        this.handleSubcommitteeChange = this.handleSubcommitteeChange.bind(this);
        this.handleCurrentlyToggle = this.handleCurrentlyToggle.bind(this);
    };

    componentDidMount() {
        let committeeParams = "sessionCode=" + this.props.session.selectedSession.SessionCode + "&includeSubCommittees=true"
        this.props.actions.getCommitteeList(committeeParams)
        this.props.actions.getBillStatusCategoryReferences().then(() => {
            let billStatusReferences = [...this.props.bills.billStatusCategoryReferences];
            billStatusReferences.forEach(ref => {
                ref.label = ref.Name
                ref.value = ref.LegislationCategoryID
            });
            this.setState({
                billStatusReferences
            })
        })
        this.setState({
            isLoaded: true
        })
    }

    componentWillUnmount() {
        cancelRequest();
    }

    fetchTableData() {
        this.props.actions.getImpactStatements()
    }

    handleBillNumberChange(e) {
        this.setState({
            billNumber: e.target.value
        })
    }

    handleCalendarDateChange(value) {
        this.setState({
            calendarDate: value
        })
    }

    handleCurrentlyToggle() {
        this.setState({
            currently: !this.state.currently
        })
    }

    handleStatusChange(value) {
        this.setState({
            status: value
        })
    }

    handleCommitteeChange(value) {
        this.setState({
            committee: value
        })
    }

    handleSubcommitteeChange(value) {
        this.setState({
            subcommittee: value
        })
    }

    render() {
        return (
            <div>
                <div className="header-half">
                    <h1>Fiscal Impact Statements</h1>
                </div>
                <div className="toolbar impact-statement-toolbar dlas-forms">
                    <div className="is-filter-wrapper">
                        <label>Bill #</label>
                        <input
                            style={{ width: "100%" }}
                            onChange={(e) => this.handleBillNumberChange(e)}
                        />
                    </div>
                    <div className="is-filter-wrapper">
                        <label>Calendar Date</label>
                        <DatePicker
                            selected={this.state.calendarDate}
                            onChange={this.handleCalendarDateChange}
                            wrapperClassName="statement-datepicker"
                            isClearable
                        />
                    </div>
                    <div className="is-filter-wrapper">
                        <label>Status</label>
                        <Select
                            value={this.state.status}
                            onChange={this.handleStatusChange}
                            styles={selectStyle}
                            options={this.state.billStatusReferences}
                            classNamePrefix='no-width-dropdown-input'
                            isClearable
                        />
                    </div>
                    <div style={{ borderRight: "1px solid #CCC", height: "100%" }} />
                    <div className="is-filter-wrapper">
                        <label>Committee</label>
                        <Select
                            value={this.state.committee}
                            onChange={this.handleCommitteeChange}
                            styles={selectStyle}
                            classNamePrefix='no-width-dropdown-input'
                            options={[...this.props.committee.committeeList.filter(x => !x.ParentCommitteeID)]}
                            getOptionLabel={o => o.ChamberCode + " - " + o.Name}
                            getOptionValue={o => o.CommitteeNumber}
                            isClearable
                        />
                    </div>
                    <div className="is-filter-wrapper">
                        <label>Subcommittee</label>
                        <Select
                            value={this.state.committee ? this.state.subcommittee : ""}
                            onChange={this.handleSubcommitteeChange}
                            styles={selectStyle}
                            classNamePrefix='no-width-dropdown-input'
                            isDisabled={!this.state.committee || this.state.committee === ""}
                            options={this.state.committee ? [...this.props.committee.committeeList.filter(x => x.ParentCommitteeID === this.state.committee.CommitteeID)] : []}
                            getOptionLabel={o => o.Name}
                            getOptionValue={o => o.CommitteeNumber}
                            isClearable
                        />
                    </div>
                    <div className="is-filter-wrapper">
                        <label>Currently</label>
                        <div className="toggle-switch" onClick={() => this.handleCurrentlyToggle()}>
                            <input id="se-currently-toggle" checked={this.state.currently} type="checkbox" style={{ width: "auto" }} />
                            <span className="slider"></span>
                        </div>
                    </div>
                </div>
                <ReactTable
                    resizable={false}
                    loading={!this.state.isLoaded}
                    data={this.state.impactStatements}
                    ref={r => this.reactTable = r}
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    onFilteredChange={() => console.log("Party")/* this.onFilteredChange.bind(this) */}
                    columns={[
                        {
                            Header: "",
                            accessor: "",
                            id: "billDetailsLinks",
                            width: 50
                        },
                        {
                            Header: "Doc #",
                            accessor: "documentNumber",
                            id: "documentNumber",
                            width: 150
                        },
                        {
                            Header: "Agency",
                            accessor: "agencyName",
                            id: "agencyName",
                            width: 100
                        },
                        {
                            Header: "",
                            accessor: "flag",
                            id: "flag",
                            width: 50
                        },
                        {
                            Header: "Impact Statement",
                            accessor: "impactStatement",
                            id: "impactStatement",
                        },
                        {
                            Header: "Status",
                            accessor: "status",
                            id: "status",
                            width: 150
                        }
                    ]}
                    defaultSorted={[

                    ]}
                    defaultPageSize={20}
                    pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
                    className="committee-table -striped -highlight"
                    minRows={5}
                />
            </div>
        );
    }
}

const ImpactStatementManagementGrid = connect(
    (state) => {
        const { session, nav, impact, committee, bills } = state;
        return {
            session,
            nav,
            impact,
            committee,
            bills
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, sessionActionCreators, navActionCreators, impactStatementActionCreators, committeeActionCreators, billActionCreators), dispatch)
        }
    }
)(ImpactStatementGridComponent)


export default ImpactStatementManagementGrid;